import { render, staticRenderFns } from "./mainProcess.vue?vue&type=template&id=2df75800&scoped=true"
import script from "./mainProcess.vue?vue&type=script&lang=js"
export * from "./mainProcess.vue?vue&type=script&lang=js"
import style0 from "./mainProcess.vue?vue&type=style&index=0&id=2df75800&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df75800",
  null
  
)

export default component.exports